import {type PersistableAppState} from './persistable-app-state'
import {type ConfigReduxState} from '../state/config/state'
import {type IndicatorsReduxState} from '../state/indicators/state'
import {type LocationsReduxState} from '../state/locations/state'
import {type NodesReduxState} from '../state/nodes/state'
import {type RolesReduxState} from '../state/roles/state'
import {type ThreatMeasuresReduxState} from '../state/threat-measures/state'
import {type LatestEventTimestampsReduxState} from '../state/latest-event-timestamps/state'
import {type UsersReduxState} from '../state/users/state'
import {type WasValueReduxState} from '../state/was-value/state'
import {type WasTrendReduxState} from '../state/was-trend/state'
import {type WatchReduxState} from '../state/watched-nodes/state'
import {type LatestLocationThreatScoresReduxState} from '../state/latest-location-threat-scores/state'
import {type SessionDataReduxState} from '../state/session-data/state'
import {type CurrentUserReduxState} from '../state/current-user/state'
import {type VesselFiltersState} from '../state/my-vessels-filters/types/my-vessel-filter-state'
import {type IncidentsFilterReduxState} from '../state/incidents-filter/state'
import {type LatestUnknownDataReduxState} from '../state/latest-unknown-asset/state'
import {type IncidentTypesReduxState} from '../state/incident-types/state'
import {type UnsavedIncidentNoteAlertModalReduxState} from '../state/unsaved-incident-note-alert-modal/state'
import {type WatchIncidentsReduxState} from '../state/watched-incidents/state'
import {type CurrentEmailRecipientsReduxState} from '../state/email-recipient-management/state'
import {type VesselTagReduxState} from '../state/vessel-tags/state'
import {type LocationTagsSummaryReduxState} from '../state/location-tags-summary/state'
import {type VesselFilterReduxState} from '../state/vessel-filter/types/vessel-filter-state'
import {type ReportsFilterReduxState} from '../state/reports-filter/state'
import {type NetworkAssetsFilterReduxState} from '../state/network-assets-filter/state'
import {type AuditLogReduxState} from '../state/audit-log/state'
import {type LocationTagThreatScoreReduxState} from '../state/location-tag-score/state'
import {type UsbInventoryFilterReduxState} from '../state/usb-inventory-filter/state'
import {type SoftwareInventoryFilterReduxState} from '../state/software-inventory-filter/state'
import {type SavedFiltersReduxState} from '../state/saved-filters/state'
import {type ExtendedDataRequestReduxState} from '../state/extended-data-request/state'
import {type MetricsBetaFilterReduxState} from '../state/metrics-filter-beta/state'
import {type MetricTypesReduxState} from '../state/metric-types/metric-types.types'
import {type VesselManagementFilterReduxState} from '../state/vessel-management-filter/state'
import {type OTAssetStateReduxState} from '../state/ot-assets/state'
import {type IncidentsReportFilterReduxState} from '../state/incidents-report-filter/state'
import {type FeedbackModalReduxState} from '../state/feedback/state'

export interface AppState extends PersistableAppState {
    wasValue: WasValueReduxState
    wasTrend: WasTrendReduxState
    indicators: IndicatorsReduxState
    roles: RolesReduxState
    nodes: NodesReduxState
    threatMeasures: ThreatMeasuresReduxState
    locations: LocationsReduxState
    latestEventTimestamps: LatestEventTimestampsReduxState
    users: UsersReduxState
    watchedNodes: WatchReduxState
    latestLocationThreatScores: LatestLocationThreatScoresReduxState
    sessionData: SessionDataReduxState
    config: ConfigReduxState
    currentUser: CurrentUserReduxState
    myVesselsFilter: VesselFiltersState
    incidentsFilter: IncidentsFilterReduxState
    latestUnknownAsset: LatestUnknownDataReduxState
    incidentTypes: IncidentTypesReduxState
    unsavedIncidentNoteAlertModal: UnsavedIncidentNoteAlertModalReduxState
    watchIncidents: WatchIncidentsReduxState
    emailRecipientData: CurrentEmailRecipientsReduxState
    vesselTags: VesselTagReduxState
    locationTagsSummary: LocationTagsSummaryReduxState
    vesselFilter: VesselFilterReduxState
    reportsFilter: ReportsFilterReduxState
    networkAssetsFilter: NetworkAssetsFilterReduxState
    usbInventoryFilter: UsbInventoryFilterReduxState
    softwareInventoryFilter: SoftwareInventoryFilterReduxState
    auditLog: AuditLogReduxState
    locationTagThreatScore: LocationTagThreatScoreReduxState
    savedFilters: SavedFiltersReduxState
    extendedDataRequest: ExtendedDataRequestReduxState
    metricsBetaFilter: MetricsBetaFilterReduxState
    metricTypes: MetricTypesReduxState
    vesselManagementFilter: VesselManagementFilterReduxState
    OTAssets: OTAssetStateReduxState
    incidentsReportFilter: IncidentsReportFilterReduxState
    feedbackModal: FeedbackModalReduxState
}

export function toPersistableAppState(state: AppState): PersistableAppState {
    return {auth: state.auth}
}
